//Please add the language resource
const notice = {
  endDate:'EndDate',
  creator:'Creator',
  updateTime:'UpdateTime',
  createTime:'CreateTime',
  beginDate:'BeginDate',
  title:'Title',
  isUse:'IsUse',
  noticeObj:'NoticeObj',
  content:'Content',
  updater:'Updater',
  msg:{
  }
};
export default notice


// WEBPACK FOOTER //
// ./src/page/system/noticeSys/lang/notice.en.js